import { action } from 'satcheljs';
export default action('THEME_CHANGED');
//# sourceMappingURL=themeChanged.js.map